(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-region-shipping-map"]) return;
  try {
    
    window.addEventListener('DOMContentLoaded', function() {
	  d3.json("https://cdn.jsdelivr.net/npm/world-atlas@2/countries-50m.json", function(world){

        var data = window.regionShippingMapData;
        if(!data) return;

        var w = 600;
        var h = 250;
        var margin = { top: 10, bottom: 10, left: 10, right: 10 };
        var width = w - margin.left - margin.right;
        var height = h - margin.top - margin.bottom;

        var lineScale = d3.scaleSqrt().domain([0, 332]).range([0.5, 3]);
        var zoomScale = d3.scalePow().domain([10500, 200]).range([120, 900]).exponent(0.3);
        var zoomScaleLatitude = d3.scalePow().domain([85, 0]).range([120, 900]).exponent(0.3);
        var circleScale = d3.scaleSqrt().domain([100000, 200]).range([2, 3.3]);
		var centerCoordTo = getLatLngCenter(data.to.map(function(v){ return v.coord; }));
        var centerCoord = getLatLngCenter([data.fromCenter,centerCoordTo]);
        var distance = geoDistance(centerCoordTo[0],centerCoordTo[1],data.fromCenter[0],data.fromCenter[1]);
        var latitudeDelta = Math.abs(centerCoordTo[0]-data.fromCenter[0]);
		var zoomValue = Math.min(zoomScale(distance),zoomScaleLatitude(latitudeDelta));
		console.log("distance",distance);

        var reverse = function(v){return v.slice().reverse()};

        var svg = d3.select("svg#region-shipping-map")
          .attr("width", w)
          .attr("height", h)
          .attr("viewBox","0 0 "+w+" "+h)
          .append("g")
          .attr("transform",  "translate(" + margin.left + "," + margin.top + ")");

		// geoOrthographic || geoAzimuthalEquidistant 
        var projection = d3.geoEquirectangular()
          .translate([w/2, h/2])
          .center([0,0])
          .rotate([-centerCoord[1],-centerCoord[0]])
          .scale(zoomValue);

        svg.append("path")
          .datum(d3.geoGraticule().step([5, 5])())
          .attr('d', d3.geoPath().projection(projection))
          .style("fill","transparent")
          .style("stroke","#ccc"); // #CCC
          
        var countryList = topojson.feature(world, world.objects.countries).features;
        var countryPath = d3.geoPath().projection(projection);

        svg.selectAll(".country")
          .data(countryList)
          .enter()
          .append("path")
          .attr("fill", function(d){
            if(d.properties.name == data.from.key){ return "#dc3700"; }
            if(data.to.filter(function(v){ return d.properties.name === v.key }).length) { return "#00ad00"; } 
            return "#bbbbc8";
          })
          .attr("stroke","white")
          .attr("stroke-width","0.7")
          .attr("d", countryPath);

        svg.selectAll("circles")
          .data(data.to)
          .enter()
          .append("circle")
          .attr("r", 1.5)
          .attr("cx", function(d){return projection(reverse(d.coord))[0];})
          .attr("cy", function(d){return projection(reverse(d.coord))[1];})
          .style("fill","#cd0d0e");

        svg.selectAll(".arcs")
          .data(data.to)
          .enter()
          .append("path")
          .style("stroke","#cd0d0e")
          .attr("d", function(d){ return lngLatToArc(d, 1) })
          .attr("id", function(d,i){ return "arc-path-"+i; })
          .style("fill", "none")
          .style("opacity", 0.5)
          .style("stroke-width", "1");

        svg.selectAll(".circle-animation")
          .data(data.to)
          .enter()
          .append("circle")
          .style("fill","#cd0d0e")
          .attr("r",circleScale(distance))
		  .append("animateMotion")
		  .attr("dur", function(d,i){ return "2."+Math.round(5+Math.random()*4)+"s"; })
		  .attr("repeatCount","indefinite")
		  .append("mpath")
		  .attr("xlink:href",function(d,i){ return "#arc-path-"+i; })


        function geoDistance(lat1, lon1, lat2, lon2, unit) {
            if ((lat1 == lat2) && (lon1 == lon2)) { return 0; }
            else {
                var radlat1 = Math.PI * lat1/180;
                var radlat2 = Math.PI * lat2/180;
                var radtheta = Math.PI * (lon1-lon2)/180;
                var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                if (dist > 1) {
                    dist = 1;
                }
                dist = Math.acos(dist);
                dist = dist * 180/Math.PI;
                dist = dist * 60 * 1.1515;
                if (unit=="K") { dist = dist * 1.609344 }
                if (unit=="N") { dist = dist * 0.8684 }
                return dist;
            }
        }

        function lngLatToArc(d, bend){
          bend = bend || 1;
          var sourceLngLat = reverse(data.from.coord),
              targetLngLat = reverse(d.coord);

          if(targetLngLat && sourceLngLat){
            var sourceXY = projection(sourceLngLat),targetXY = projection(targetLngLat);
            var sourceX = sourceXY[0], sourceY = sourceXY[1];
            var targetX = targetXY[0], targetY = targetXY[1];
            var dx = targetX - sourceX;
			var dy = targetY - sourceY;
			var dr = Math.sqrt(dx * dx + dy * dy) * bend;
            var west_of_source = (targetX - sourceX) < 0;
            if (west_of_source){ return "M" + sourceX + "," + sourceY + "A" + dr + "," + dr + " 0 0,0 " + targetX + "," + targetY; }
            return "M" + sourceX + "," + sourceY + "A" + dr + "," + dr + " 0 0,1 " + targetX + "," + targetY;
          } else{
            return "M0,0,l0,0z";
          }
        }
        
        function getLatLngCenter(latLngInDegr) {
            function rad2degr(rad) { return rad * 180 / Math.PI; }
			function degr2rad(degr) { return degr * Math.PI / 180; }

            var sumX = 0, sumY = 0, sumZ = 0;
            for (var i=0; i<latLngInDegr.length; i++) {
                var lat = degr2rad(latLngInDegr[i][0]);
                var lng = degr2rad(latLngInDegr[i][1]);
                // sum of cartesian coordinates
                sumX += Math.cos(lat) * Math.cos(lng);
                sumY += Math.cos(lat) * Math.sin(lng);
                sumZ += Math.sin(lat);
            }
            var avgX = sumX / latLngInDegr.length;
            var avgY = sumY / latLngInDegr.length;
            var avgZ = sumZ / latLngInDegr.length;
            var lng = Math.atan2(avgY, avgX);
            var hyp = Math.sqrt(avgX * avgX + avgY * avgY);
            var lat = Math.atan2(avgZ, hyp);
            return ([rad2degr(lat), rad2degr(lng)]);
        }

      });
    });
                                                         

  } catch(e) { console.error(e); }
})();
})();
